let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i6pHp")).then(() => parcelRequire('6CqDX'));